import React from 'react'
import { Button, Card, CardBody, CardHeader, Col, Label, Row, Modal, ModalBody, ModalFooter, ModalHeader, Nav, NavItem, NavLink, TabContent, TabPane, Form, FormFeedback, FormGroup, FormText, Input, Spinner } from 'reactstrap'
import axios from '../utils/posAxios'
import StorageService from '../services/StorageService'
import NotificationSystem from 'react-notification-system'
import { NOTIFICATION_SYSTEM_STYLE } from '../utils/constants'
import { Redirect } from 'react-router'
import moment from 'moment-timezone'
import { MDBDataTableV5, MDBIcon } from 'mdbreact'
import '@fortawesome/fontawesome-free/css/all.min.css'
import classnames from 'classnames'
import { getUser, getUser_v2 } from '../utils/dropdownlist'
import { MdDone, MdWarning, MdModeEdit } from 'react-icons/md'
import { FaEdit } from 'react-icons/fa'
import { IconContext } from 'react-icons/lib'
import { CSVLink } from 'react-csv'
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table'
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css'
import Select from 'react-select'

const headers = [
  {
    label: 'Order ID',
    key: 'order_id',
  },
  {
    label: 'Service',
    key: 'service_type',
  },
  {
    label: 'Status',
    key: 'order_status',
  },
  {
    label: 'Payment',
    key: 'payment_status',
  },
  {
    label: 'Total Price',
    key: 'total_price',
  },
  // {
  //   label: 'Category',
  //   key: 'category',
  // },
  // {
  //   label: 'Product No.',
  //   key: 'product_no',
  // },
  // {
  //   label: 'Name',
  //   key: 'name',
  // },
  // {
  //   label: 'Quantity',
  //   key: 'qty',
  // },
  {
    label: 'Schedule Date',
    key: 'schedule_date',
  },
  {
    label: 'Start Time',
    key: 'starttime',
  },
  {
    label: 'End Time',
    key: 'endtime',
  },
  {
    label: 'Customer',
    key: 'customer',
  },
  {
    label: 'Contact',
    key: 'contact',
  },
  {
    label: 'Address',
    key: 'address',
  },
  {
    label: 'Postal Code',
    key: 'postal_code',
  },
  {
    label: 'Billing Contact',
    key: 'billing_contact',
  },
  {
    label: 'Order Message',
    key: 'order_msg',
  },
]

const tbcolumn = [
  {
    label: 'Order ID',
    field: 'order_id',
    sort: 'asc',
  },
  {
    label: 'Service',
    field: 'service_type',
    sort: 'asc',
  },
  {
    label: 'Status',
    field: 'order_status',
    sort: 'asc',
  },
  {
    label: 'Payment',
    field: 'payment_status',
    sort: 'asc',
  },
  {
    label: 'Schedule Date',
    field: 'schedule_date',
    sort: 'asc',
  },
  {
    label: 'Customer',
    field: 'customer',
    sort: 'asc',
  },
  {
    label: 'Contact',
    field: 'contact',
    sort: 'asc',
  },
  {
    label: 'Postal Code',
    field: 'postal_code',
    sort: 'asc',
  },
  {
    label: 'Action',
    field: 'Action',
    sort: 'asc',
  },
]

class ScheduleOrderList extends React.Component {
  _isMounted = true
  ScheduleOrderList = StorageService.getSession('ScheduleOrderList')
  access = StorageService.getSession('user_access')
  comp = StorageService.getSession('selected_org')
  constructor(props) {
    super(props)
    let storeid = this.ScheduleOrderList && this.ScheduleOrderList.store_id ? this.ScheduleOrderList.store_id : this.props.data.storeList[0].store_id
    let storeRole = this.access.store.find(x => x.store_id == storeid).role
    this.state = {
      paymentModal: false,
      completeModal: false,
      batchModal: false,
      redirect: false,
      isLoading: false,
      isManageablePayment: storeRole === 'Manager' || storeRole === 'Superuser' || storeRole === 'Admin' || storeRole === 'Supervisor' || storeRole === 'Financial' ? true : false,
      store_id: this.ScheduleOrderList && this.ScheduleOrderList.store_id ? this.ScheduleOrderList.store_id : this.props.data.storeList[0].store_id,
      storeList: this.props.data.storeList,
      date: this.ScheduleOrderList && this.ScheduleOrderList.date ? this.ScheduleOrderList.date : moment().subtract(1, 'days').tz('Asia/Singapore').format('YYYY-MM-DD'),
      fm_date: this.ScheduleOrderList && this.ScheduleOrderList.fm_date ? this.ScheduleOrderList.fm_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      to_date: this.ScheduleOrderList && this.ScheduleOrderList.to_date ? this.ScheduleOrderList.to_date : moment().tz('Asia/Singapore').format('YYYY-MM-DD'),
      reportList: [],
      paymentList: [],
      payment_amount: '',
      payment_data: '',
      payment_reference: '',
      selectedID: '',
      selectedStore_id: '',
      total_outstanding: '',
      send_receipt: 0,
      search_type: this.ScheduleOrderList && this.ScheduleOrderList.search_type ? this.ScheduleOrderList.search_type : 'Order',
      unpaidonly: this.ScheduleOrderList && this.ScheduleOrderList.unpaidonly ? this.ScheduleOrderList.unpaidonly : 0,
      showservice: this.ScheduleOrderList && this.ScheduleOrderList.showservice ? this.ScheduleOrderList.showservice : 0,
      payment_store_id: '',
    }
  }

  componentDidMount() {
    //if (this.OrderScheduleList) {
    this.getReport()
    this.getPaymentList(this.state.store_id)

    let companyRole = this.comp.Role

    let storeList = [...this.props.data.storeList]
    if (companyRole == 'Admin') {
      let data = {
        store_id: 0,
        name: 'All',
      }
      storeList.push(data)
    }

    this.setState({ storeList })
    //}
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  changeHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: value,
    })
    let data = this.ScheduleOrderList ? this.ScheduleOrderList : {}
    data[name] = value
    StorageService.setSession('ScheduleOrderList', data)
    this.ScheduleOrderList = StorageService.getSession('ScheduleOrderList')
  }

  checkHandler = e => {
    const { name, value } = e.target
    this.setState({
      [name]: !this.state[name],
    })
    if (name != 'send_receipt') {
      let data = this.ScheduleOrderList ? this.ScheduleOrderList : {}
      data[name] = !this.state[name]
      StorageService.setSession('ScheduleOrderList', data)
      this.ScheduleOrderList = StorageService.getSession('ScheduleOrderList')
    }
  }

  storeHandler = e => {
    const { label, value } = e
    this.setState({
      store_id: value,
      reportList: [],
    })
    let data = this.paymentDetail ? this.paymentDetail : {}
    data['store_id'] = value
    StorageService.setSession('PaymentReport', data)
    this.paymentDetail = StorageService.getSession('PaymentReport')
    // if (value != 0) {
    //   this.getPaymentList(value)
    // }
  }

  getPaymentList = store_id => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: store_id,
    }

    axios
      .post(url + ':3001/v1/store/payment', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        if (this._isMounted) {
          this.setState({ paymentList: result.data })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  getReport() {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      company_id: comp.CompanyID,
      store_id: this.state.store_id,
      fm_date: this.state.fm_date,
      to_date: this.state.to_date,
      search_type: this.state.search_type,
      unpaidonly: this.state.unpaidonly == 1 ? '1' : '0',
      showservice: this.state.showservice == 1 ? '1' : '0',
    }

    axios
      .post(url + ':3003/v3/order/report/schedule/order', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }

        for (let i of result.data) {
          i.Action = (
            <div className="ps-action-button">
              {i.order_id != 'Grand Total' && i.order_id != '' && (
                <Button className="theme-button theme-button-secondary" onClick={() => this.props.order(i.store_id, i.order_id)}>
                  View
                </Button>
              )}
              {i.payment_status === 'Pending Payment' && (
                <Button className="theme-button theme-button-primary-light" onClick={this.paymentModal(i.order_id, i.store_id, i.total_outstanding)}>
                  Pay
                </Button>
              )}
              {i.order_status !== 'Completed' && i.order_id != 'Grand Total' && i.order_id != '' && (
                <Button className="theme-button theme-button-primary" onClick={this.completeModal(i.order_id, i.store_id)}>
                  Complete
                </Button>
              )}
            </div>
          )
        }

        if (this._isMounted) {
          this.setState({
            reportList: result.data,
          })
        }
      })
      .catch(error => {
        alert(error)
      })
  }

  paymentModal =
    (order_id = '', store_id = '', total_outstanding = '') =>
    () => {
      if (this.state.isManageablePayment) {
        if (this.state.paymentList.length > 0) {
          if (order_id !== '') {
            this.setState({ isLoading: true, payment_type: '', payment_data: '', payment_reference: '', payment_amount: '', payment_store_id: store_id, send_receipt: 0 })
            this.getPaymentList(store_id)
            this.paymentAmount(order_id, store_id)
          }
        } else {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: 'Payment List Is Empty',
            level: 'warning',
            position: 'br',
            autoDismiss: 4,
            dismissible: 'click',
          })
        }
        // return this.setState({
        //   paymentModal: !this.state.paymentModal,
        //   payment_amount: total_outstanding,
        //   selectedID: order_id,
        // });
      }
    }

  completeModal =
    (order_id = '', store_id = '') =>
    () => {
      if (this.state.isManageablePayment) {
        return this.setState({
          completeModal: !this.state.completeModal,
          selectedID: order_id,
          selectedStore_id: store_id,
        })
      }
    }

  batchModal = () => () => {
    if (this.state.isManageablePayment) {
      return this.setState({
        batchModal: !this.state.batchModal,
      })
    }
  }

  offModal = () => () => {
    return this.setState({
      paymentModal: false,
    })
  }

  paymentAmount(order_id, store_id) {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: order_id,
      store_id: store_id,
    }

    axios
      .post(url + ':3003/v1/order/detail', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.setState({
          paymentModal: !this.state.paymentModal,
          payment_amount: result.data.total_outstanding,
          selectedID: order_id,
          isLoading: false,
        })
      })
      .catch(error => {
        alert(error)
      })
  }

  payment = e => {
    e.preventDefault()
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL

    let payment = this.state.paymentList.find(x => x.id == this.state.payment_type)

    let payment_item = {
      payment_id: this.makeid(20),
      payment_type_id: payment.id,
      payment_type: payment.name,
      amount: this.state.payment_amount,
      data: this.state.payment_data,
      reference: this.state.payment_reference,
    }

    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      order_id: this.state.selectedID,
      store_id: this.state.payment_store_id,
      send_receipt: this.state.send_receipt ? '1' : '0',
      payment_item: payment_item,
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v2/order/payment/add', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          alert(result.message)
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Reference updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.setState({
          paymentModal: false,
          payment_data: '',
          payment_reference: '',
          payment_amount: '',
          send_receipt: 0,
        })
        this.getReport()
      })
      .catch(error => {
        alert(error)
      })
  }

  status = () => {
    const user = StorageService.getSession('user_info')
    const comp = StorageService.getSession('selected_org')
    const url = process.env.REACT_APP_UNITY_API2_URL
    const data = {
      session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
      store_id: this.state.selectedStore_id,
      order_id: this.state.selectedID,
      status: 'Completed',
      updated_by: user.email,
    }

    axios
      .post(url + ':3003/v1/order/status', data)
      .then(response => {
        const result = response.data
        if (result.error == true && result.message != 'Success') {
          this.notificationSystem.addNotification({
            title: <MdWarning />,
            message: result.message,
            level: 'error',
            position: 'tc',
            autoDismiss: 4,
            dismissible: 'click',
          })
          this.setState({
            order_status: 'Attention',
          })
          return
        }
        this.notificationSystem.addNotification({
          title: <MdDone />,
          message: 'Status updated successfully.',
          level: 'success',
          position: 'br',
          autoDismiss: 4,
          dismissible: 'click',
        })
        this.getReport()
        this.setState({ completeModal: false })
      })
      .catch(error => {
        alert(error)
      })
  }

  BatchComplete = () => {
    if (this.state.reportList.filter(x => x.order_id != 'Grand Total').length > 0) {
      const user = StorageService.getSession('user_info')
      const comp = StorageService.getSession('selected_org')
      const url = process.env.REACT_APP_UNITY_API2_URL
      let order_list = []
      for (let i of this.state.reportList) {
        if (i.order_id != 'Grand Total') {
          order_list.push(i.order_id)
        }
      }
      const data = {
        session_key: 'MEmnAwcpRdVhAjWqqswddeRxTBrMsPzdmNvwXRyr',
        store_id: this.state.store_id,
        order_list: order_list,
        status: 'Completed',
        updated_by: user.email,
      }
      axios
        .post(url + ':3003/v1/order/status/batch', data)
        .then(response => {
          const result = response.data
          if (result.error == true && result.message != 'Success') {
            this.notificationSystem.addNotification({
              title: <MdWarning />,
              message: result.message,
              level: 'error',
              position: 'tc',
              autoDismiss: 4,
              dismissible: 'click',
            })
            // this.setState({
            //   order_status: 'Attention',
            // });
            return
          }

          setTimeout(() => {
            this.notificationSystem.addNotification({
              title: <MdDone />,
              message: 'Status updated successfully.',
              level: 'success',
              position: 'br',
              autoDismiss: 4,
              dismissible: 'click',
            })
            this.getReport()
            this.setState({ batchModal: false })
          }, 1000)
        })
        .catch(error => {
          alert(error)
        })
    } else {
      this.notificationSystem.addNotification({
        title: <MdWarning />,
        message: 'Order Not Found',
        level: 'warning',
        position: 'br',
        autoDismiss: 4,
        dismissible: 'click',
      })
    }
  }

  CsvNotFound() {
    this.notificationSystem.addNotification({
      title: <MdWarning />,
      message: 'Data Not Found',
      level: 'warning',
      position: 'br',
      autoDismiss: 4,
      dismissible: 'click',
    })
  }

  makeid(length) {
    var result = ''
    var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    var charactersLength = characters.length
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength))
    }
    return result
  }

  render() {
    let data = {
      columns: tbcolumn,
      rows: this.state.reportList,
    }
    let options = [
      ...this.state.storeList
        .reduce((r, o) => {
          let key = o.store_id
          let item = { value: o.store_id, label: o.name }
          return r.set(key, item)
        }, new Map())
        .values(),
    ]
    return (
      <>
        <NotificationSystem dismissible={false} ref={notificationSystem => (this.notificationSystem = notificationSystem)} style={NOTIFICATION_SYSTEM_STYLE} />
        {this.state.isLoading && (
          <div
            style={{
              position: 'fixed',
              top: '50%',
              left: '50%',
              marginTop: -16,
              marginLeft: -16,
              zIndex: 1,
            }}>
            <Spinner animation="border" variant="primary" />
          </div>
        )}
        <Row>
          <Col>
            <h5>Orders Report</h5>
          </Col>
        </Row>
        <Row>
          <Col md={3}>
            <Label>Store</Label>
            {/* <Input
              className="ps-input-small"
              type="select"
              name="store_id"
              value={this.state.store_id}
              onChange={this.changeHandler}
            >
              {this.state.storeList.map(item => {
                return (
                  <option key={item.store_id} value={item.store_id}>
                    {item.name}
                  </option>
                );
              })}
            </Input> */}
            <Select options={options} value={options.filter(i => i.value == this.state.store_id)} name="store_id" onChange={this.storeHandler} menuPosition={'fixed'} required />
          </Col>
          <Col md={2}>
            <Label> Date</Label>
            <Input className="ps-input-small" type="date" name="fm_date" onChange={this.changeHandler} value={this.state.fm_date} />
          </Col>
          <Col md={1}>
            <Label></Label>
            <p
              style={{
                padding: '0.4rem',
                textAlign: 'center',
                whiteSpace: 'nowrap',
              }}>
              To
            </p>
          </Col>
          <Col md={2}>
            <Label> Date</Label>
            <Input className="ps-input-small" type="date" name="to_date" onChange={this.changeHandler} value={this.state.to_date} />
          </Col>
          <Col md={2}>
            <Label>Search Type</Label>
            <Input className="ps-input-small" type="select" name="search_type" value={this.state.search_type} onChange={this.changeHandler}>
              <option value="Order">Order</option>
              <option value="Fulfilment">Fulfilment</option>
            </Input>
          </Col>
          {/* <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col> */}
        </Row>

        <Row>
          <Col md={2}>
            <FormGroup check>
              <Label check>
                <Input className="ps-input-small" type="checkbox" name="unpaidonly" onChange={this.checkHandler} checked={this.state.unpaidonly} />
                Unpaid Only
              </Label>
            </FormGroup>
          </Col>

          <Col md={2}>
            <FormGroup check>
              <Label check>
                <Input className="ps-input-small" type="checkbox" name="showservice" onChange={this.checkHandler} checked={this.state.showservice} />
                Show Services
              </Label>
            </FormGroup>
          </Col>

          <Col md={2} className="ps-margin-auto-desktop">
            <Button className="ps-input-small" onClick={() => this.getReport()}>
              Search
            </Button>
          </Col>

          <Col md={6}></Col>
        </Row>

        <Row>
          <Col>
            <CSVLink
              data={this.state.reportList}
              headers={headers}
              filename={'OrdersReport_' + moment(this.state.fm_date, 'YYYY-MM-DD').format('YYMMDD') + '_' + moment(this.state.to_date, 'YYYY-MM-DD').format('YYMMDD') + '.csv'}
              onClick={() => {
                if (this.state.reportList.length < 1) {
                  this.CsvNotFound()
                  return false
                }
              }}>
              <Button type="button" className="ps-input-small theme-button-primary">
                Export
              </Button>
            </CSVLink>

            <Button className="ps-input-small theme-button-primary-light" onClick={this.batchModal()} disabled={this.state.store_id == 0 ? true : false}>
              Batch Complete
            </Button>
          </Col>
        </Row>

        <Row>
          <Col>
            <Table className="ps-table tb-col-10 ps-responsive-table">
              <Thead>
                <Tr>
                  <Th>Order ID</Th>
                  <Th>Service</Th>
                  <Th>Status</Th>
                  <Th>Payment</Th>
                  <Th>Total Price</Th>
                  <Th>Schedule Date</Th>
                  <Th>Customer</Th>
                  <Th>Contact</Th>
                  <Th>Postal Code</Th>
                  <Th>Action</Th>
                </Tr>
              </Thead>
              <Tbody>
                {this.state.reportList.length < 1 && (
                  <Tr>
                    <Td colSpan="10">
                      <div className="ps-empty-data">
                        <div className="empty-content">
                          <h4>No data to show</h4>
                        </div>
                      </div>
                    </Td>
                  </Tr>
                )}
                {this.state.reportList.map((item, index) => {
                  return (
                    <Tr key={index}>
                      <Td>{item.order_id}</Td>
                      <Td>{item.service_type}</Td>
                      <Td>{item.order_status}</Td>
                      <Td>{item.payment_status}</Td>
                      <Td>{item.total_price}</Td>
                      <Td>{item.schedule_date}</Td>
                      <Td>{item.customer}</Td>
                      <Td>{item.contact}</Td>
                      <Td>{item.postal_code}</Td>
                      <Td>{item.Action}</Td>
                    </Tr>
                  )
                })}
              </Tbody>
            </Table>
            {/* <MDBDataTableV5
              className="ps-order-table th-11"
              data={data}
              displayEntries={false}
              entries={100}
              searchTop
              searchBottom={false}
              noRecordsFoundLabel="No data to show"
              fullPagination
              disableRetreatAfterSorting={true}
              responsive={true}
              
            /> */}
          </Col>
          <Modal isOpen={this.state.paymentModal} toggle={this.offModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
            <Form onSubmit={this.payment}>
              <ModalHeader toggle={this.offModal()}>Payment</ModalHeader>
              <ModalBody>
                <Row>
                  <Col md={12}>
                    <FormGroup>
                      <Input type="select" name="payment_type" value={this.state.payment_type} onChange={this.changeHandler} required>
                        <option></option>
                        {this.state.paymentList.map(item => {
                          return (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          )
                        })}
                      </Input>
                    </FormGroup>
                    <FormGroup>
                      <Label>Amount</Label>
                      <Input type="text" name="payment_amount" value={this.state.payment_amount} onChange={this.changeHandler} required />
                    </FormGroup>
                    <FormGroup>
                      <Label>Remark</Label>
                      <Input type="text" name="payment_data" value={this.state.payment_data} onChange={this.changeHandler} />
                    </FormGroup>
                    <FormGroup>
                      <Label>Reference</Label>
                      <Input type="text" name="payment_reference" value={this.state.payment_reference} onChange={this.changeHandler} />
                    </FormGroup>
                    <FormGroup check>
                      <Label check>
                        <Input type="checkbox" name="send_receipt" checked={this.state.send_receipt} onChange={this.checkHandler} />
                        Send Receipt
                      </Label>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                <Button className="theme-button theme-button-primary" type="submit">
                  Save
                </Button>
              </ModalFooter>
            </Form>
          </Modal>
          <Modal isOpen={this.state.completeModal} toggle={this.completeModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
            <ModalHeader toggle={this.completeModal()}>Complete Order</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <p>
                    Are you sure you want to complete order
                    {' ' + this.state.selectedID} ?
                  </p>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-secondary" onClick={this.completeModal()}>
                No
              </Button>
              <Button className="theme-button theme-button-primary" onClick={() => this.status()}>
                Yes
              </Button>
            </ModalFooter>
          </Modal>

          <Modal isOpen={this.state.batchModal} toggle={this.batchModal()} className={this.props.className} centered style={{ fontSize: '0.85rem' }}>
            <ModalHeader toggle={this.batchModal()}>Complete Batch Order</ModalHeader>
            <ModalBody>
              <Row>
                <Col md={12}>
                  <p>Are you sure you want to complete batch order ?</p>
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter>
              <Button className="theme-button theme-button-secondary" onClick={this.batchModal()}>
                No
              </Button>
              <Button className="theme-button theme-button-primary" onClick={() => this.BatchComplete()}>
                Yes
              </Button>
            </ModalFooter>
          </Modal>
        </Row>
      </>
    )
  }
}

export default ScheduleOrderList
